/* Copyright 2013 - 2022 Waiterio LLC */
/** @jsx jsx */
import React, { useState } from 'react'
import { css, jsx } from '@emotion/core'
import { withRouter } from 'react-router-dom'
import field from '@waiterio/styles/field.js'
import fieldLabel from '@waiterio/styles/fieldLabel.js'
import fieldValue from '@waiterio/styles/fieldValue.js'
import greenButton from '@waiterio/styles/greenButton.js'
import inputable from '@waiterio/styles/inputable.js'
import postLogin from '../postLogin.js'
import storeNewSession from '../session/storeNewSession.js'

const LoginPage = ({ history }) => {
  let [email, setEmail] = useState()
  let [password, setPassword] = useState()
  let [error, setError] = useState()

  const changeEmail = event => {
    setEmail(event.target.value)
  }

  const changePassword = event => {
    setPassword(event.target.value)
  }

  const showError = error => {
    console.error(error)

    setError(error?.message)
  }

  const onSubmit = async event => {
    try {
      event.preventDefault()

      const loginResponse = await postLogin(email, password)
      await storeNewSession(loginResponse)
      history.push('/upload')
    } catch (error) {
      showError(error)
    }
  }

  return (
    <div
      css={{
        height: '100%',
        margin: '0 auto',
        maxWidth: '320px',
        marginBottom: 16,
      }}
    >
      <div
        css={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: '-48px',
        }}
      >
        <form
          onSubmit={onSubmit}
          autoComplete="on"
          css={{
            width: '100%',
            boxShadow:
              '0 1.5px 4px rgba(0, 0, 0, 0.24), 0 0.5px 2px rgba(0, 0, 0, 0.19)',
            backgroundColor: 'white',
          }}
        >
          <div css={[inputable, field]}>
            <label htmlFor="emailInput" css={fieldLabel}>
              email
            </label>
            <input
              id="emailInput"
              css={fieldValue}
              type="email"
              name="email"
              autoComplete="email"
              autoCapitalize="none"
              autoCorrect="off"
              required
              value={email || ''}
              onChange={changeEmail}
            />
          </div>
          <div css={[inputable, field]}>
            <label htmlFor="passwordInput" css={fieldLabel}>
              password
            </label>
            <input
              id="passwordInput"
              css={fieldValue}
              type="password"
              name="password"
              autoComplete="current-password"
              autoCapitalize="none"
              autoCorrect="off"
              required
              value={password || ''}
              onChange={changePassword}
            />
          </div>
          <button css={greenButton} type="submit">
            Login
          </button>
        </form>
        {error && <div css={{ lineHeight: '48px', color: 'red' }}>{error}</div>}
      </div>
    </div>
  )
}

export default withRouter(LoginPage)
